import { SaveActionPlanData } from "./types";
import { roundToNDecimalPlaces } from "@dcc/common/rounding";
import { usersApi } from "@dcc/api";
import { buildActionPlanUrl } from "./actionPlanUrl";
import { AppGenderToApiSex } from "../../utils";
import {
  DccActionPlanSubscribeRequest,
  subscribe
} from "drinkaware-tools-api-library";
import { Sex } from "drinkaware-tools-api-library/dist/src/clients/users/src";

const WEEKLY_DRINK_FREQUENCY = "weekly";

const buildRequestData = (
  actionPlanData: SaveActionPlanData
): DccActionPlanSubscribeRequest => {
  const {
    units: unitsPerWeek,
    calories: caloriesPerWeek
  } = actionPlanData.unitsAndCaloriesPerWeek;
  const {
    units: originalUnitsPerWeek,
    calories: originalCaloriesPerWeek
  } = actionPlanData.originalUnitsAndCaloriesPerWeek;
  const apiSex: Sex = AppGenderToApiSex(actionPlanData.gender);
  return {
    firstName: actionPlanData.firstName,
    lastName: actionPlanData.lastName,
    email: actionPlanData.email,
    age: actionPlanData.age.toString(),
    sex: apiSex,
    frequency: WEEKLY_DRINK_FREQUENCY,
    unitConsumption: roundToNDecimalPlaces(originalUnitsPerWeek, 2).toString(),
    calorieBaseline: roundToNDecimalPlaces(
      originalCaloriesPerWeek,
      2
    ).toString(),
    droppedDays: actionPlanData.droppedDays.toString(),
    caloriesWeek: roundToNDecimalPlaces(caloriesPerWeek, 2).toString(),
    unitsWeek: roundToNDecimalPlaces(unitsPerWeek, 2).toString(),
    percentage: actionPlanData.percentage.toString(),
    tips: actionPlanData.tips.toString(),
    actionPlanUrl: buildActionPlanUrl({
      tips: actionPlanData.tips,
      unitsPerWeek: unitsPerWeek,
      caloriesPerWeek: caloriesPerWeek,
      droppedDays: actionPlanData.droppedDays,
      percentage: actionPlanData.percentage,
      gender: actionPlanData.gender,
      numDrinkingDays: actionPlanData.numDrinkingDays
    })
  };
  // TODO - bring query string into line with @/types/Gender ?
};

export const sendSaveActionPlanRequest = (
  actionPlanData: SaveActionPlanData
) => {
  const body = buildRequestData(actionPlanData);
  subscribe({
    users: usersApi,
    body,
    clientId: actionPlanData.clientId
  });
};
